import * as AbsintheSocket from '@absinthe/socket'
import { createAbsintheSocketLink } from '@absinthe/socket-apollo-link'
import { Socket as PhoenixSocket } from 'phoenix'
import config from '../config'

const params = {
  'x-api-key': config.api_key
}

const phoenixSocket = new PhoenixSocket(config.pi_graphql_ws, { 
  params,
  reconnectAfterMs: (tries) => [1000, 2000, 5000, 10000][tries - 1] || 10000
})

phoenixSocket.onError((error) => {
  console.warn('Phoenix WebSocket error:', error)
})

export default createAbsintheSocketLink(AbsintheSocket.create(phoenixSocket))
